import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams, data } from "react-router-dom";
import { getFirestore, doc, setDoc, getDoc, query, where, getDocs, updateDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import Photosicon from '../../assets/photos_icon.png';
import { Randomcode } from '../../components/rendom_code';
import { Helmet } from "react-helmet";
import Lodinging from "../../components/loading";
import Cookies from 'js-cookie';
import { useToast } from '../../components/ToastContext';
import Statusbarpopup from '../../master_root/statusbarpopup';
import Statusbar from '../../master_root/statusbar';
import './item-master.css';
//page links  
import { RxDragHandleDots2 } from "react-icons/rx";
import { MdSearch, MdAdd, MdSettings, MdMoreHoriz, MdOutlineAddTask, MdCopyAll, MdRemoveCircle, MdDeleteForever, MdDeleteOutline } from 'react-icons/md';
import { TbEyeEdit } from "react-icons/tb";
import { CgLockUnlock, CgLock } from "react-icons/cg";
import { preMaster } from './pre_master';
export default function ItemMasterManagemnet() {
  const { showToast } = useToast();
  const [adminguid, setadminguid] = useState(Cookies.get("adminguid"));
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [mastername, setmastername] = useState('');
  const [typename, settypename] = useState('');
  const [selectedColor, setSelectedColor] = useState("#3B82F6");
  const [puid, setPuid] = useState("");
  const [premasterdata, setpremasterdata] = useState("");

  const create_pre_master = async () => {
    if (!typename.trim() || !mastername.trim()) {
      showToast("Please fill in all required fields.");
      return;
    }
    setLoading(true);
    try {
      const masteruid = Randomcode(20);
      const result = await preMaster({
        mastername,
        masteruid,
        typename,
        color: selectedColor,
      });

      if (result.success) {
        showToast("Successfully.");
        fetch_premaster();
      } else {
        showToast("Failed to create item: " + (result.error || "Unknown error"));
      }
    } catch (ex) {
      console.error("An error occurred:", ex);
      showToast("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  const handleColorClick = (color) => {
    setSelectedColor(color);
    console.log("Selected Color:", color); // or pass it to parent component
  };
  const colorList = [
    '#3B82F6', // Blue (Primary)
    '#10B981', // Emerald (Success)
    '#F59E0B', // Amber (Warning)
    '#EF4444', // Red (Error)
    '#6366F1', // Indigo
    '#8B5CF6', // Violet
    '#EC4899', // Pink
    '#F43F5E', // Rose
    '#0EA5E9', // Sky Blue
    '#14B8A6', // Teal
    '#22C55E', // Green
    '#EAB308', // Yellow
    '#F97316', // Orange
    '#1F2937', // Dark Slate (Text/Base)
    '#A3A3A3', // Cool Gray
    '#6B7280', // Gray
    '#94A3B8', // Slate Gray
    '#D4D4D8', // Light Gray 
  ];
  useEffect(() => {
    if (adminguid) {
      fetch_premaster();
    }
  }, [data]);
  //fetch_taskData
  const fetch_premaster = async () => {
    setIsLoading(true);
    try {
      // Fetch tasks
      const taskQuery = query(
        collection(db, "premaster"),
        where("adminguid", "==", adminguid),
        // orderBy("indexstage", "desc")
      );
      const taskSnapshot = await getDocs(taskQuery);
      const dataList = taskSnapshot.docs.map((docItem) => ({
        id: docItem.id,
        ...docItem.data()
      }));

      setpremasterdata(dataList);

    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Statusbar data={'Item Master'} />
      <div className='app_header_height'></div>

      <div className="container_roots">

        <title>Item Master Management | EditorTask - Organize & Track Your Inventory</title>

        <meta name="description" content="Efficiently manage your items and inventory with EditorTask's Item Master Management. Add, edit, and track product details seamlessly for optimal operations." />
        <meta name="keywords" content="item master, inventory management, product catalog, item tracking, stock management, EditorTask, product management, item database" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Item Master Management | EditorTask - Organize & Track Your Inventory" />
        <meta property="og:description" content="Streamline your inventory with EditorTask's Item Master Management. Maintain accurate product data, update stock, and manage your catalog efficiently." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/item-master" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />

        <div className="container_size">
          <div className='post-container'>
            <div className="contact-title">Item Master Management | EditorTask - Organize & Track Your task</div>
          </div>
          <div className='post-container'>
            <div className='post_div'>
  
            </div>
            <div className='post_updates'>
              <div className='contact-title-div'>
                <div className="contact-title">Pre Master</div>
                 <div className="contact-details">Pre Master provides ready-to-use item masters. Easily copy, assign owners, and configure settings for your item master as needed</div>
              </div>
            
              <div className="pre-item-master" style={{ borderTop: `solid 4px ${selectedColor}` }}>
                <table className="form-div">
                  <tr>
                    <td>
                      <input
                        value={mastername}
                        maxLength={30}
                        className='input-box'
                        placeholder="Master Name"
                        onChange={(e) => setmastername(e.target.value)}
                      />

                    </td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        name="type"
                        placeholder="Item Type"
                        value={typename}
                        onChange={(e) => settypename(e.target.value)}
                      />
                    </td>
                  </tr>
                  <tr >
                    <td>
                      <div className='item-table' style={{ display: 'flex', flexWrap: 'wrap', maxWidth: '100%' }}>
                        {colorList.map((color, index) => (
                          <div
                            key={index}
                            onClick={() => handleColorClick(color)}
                            style={{
                              width: '20px',
                              height: '20px',
                              borderRadius: '100%',
                              backgroundColor: color,
                              cursor: 'pointer',
                              border: selectedColor === color ? '1px solid #333' : '1px solid ' + color,
                              margin: '2px'
                            }}
                          />
                        ))}
                      </div>

                    </td>
                  </tr>
                  <tr>
                    <td >
                      <div className='button-ui' onClick={create_pre_master}><MdAdd className='icon' />Add Item</div>
                    </td>
                  </tr>
                </table>
                <br/>
                <div className='table-grid'>
                  {isLoading ? (
                    <Lodinging />
                  ) : premasterdata.length === 0 ? (
                    <p>No pre master available.</p>
                  ) : (
                    <>
                      {premasterdata.map((datarow, index) => (
                        <div className='table-items' key={index} style={{ borderTop: `solid 4px ${datarow.color}` }} >
                          <table style={{ width: '100%' }}>
                            <tbody>
                              <tr>
                                <td className='item-title'>Name</td>
                                <td> 

                                 <table width='100%'><tr>
                                    <td><div className='task-name-text'>{datarow.mastername || ""}</div></td>
                                   
                                    <td width='20px'>
                                      <MdDeleteOutline title='Add Owner' className='taskicon' />
                                    </td>
                                  </tr></table>
                                  </td>
                              </tr>
                              <tr>
                                <td className='item-title'>Type</td>
                                <td><div className='task-name-text'>{datarow.typename || ""}</div></td>
                              </tr>

                              <tr>
                                <td className='item-title'>Owner</td>
                                <td>
                                  <table width='100%'><tr>
                                    <td><img className='owner-img' src={Photosicon}></img></td>
                                    <td> </td>
                                    <td> </td>
                                    <td width='20px'>
                                      <MdAdd title='Add Owner' className='taskicon' />
                                    </td>
                                  </tr></table>
                                </td>
                              </tr>

                              <tr >
                                <td className='item-title'>Create</td>
                                <td >
                                  <table width='100%'><tr>
                                    <td title='Create Date'>

                                      <span>{datarow?.date_time?.toDate?.()?.toISOString?.().split("T")[0]}</span>
                                    </td>
                                    <td><div>&nbsp;Due</div></td>
                                    <td title='Update'>
                                      <span>{datarow?.update_date_time?.toDate?.()?.toLocaleString?.()}</span>
                                    </td>
                                    <td width='20px'>
                                      <MdCopyAll title='CopyAll' className='taskicon' />
                                    </td>
                                  </tr></table>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                        </div>
                      ))}

                    </>
                  )}
                </div>
             
              </div>

            </div>
          </div>

        </div>

      </div>
    </div >
  );
}
